import { render, staticRenderFns } from "./InfopointBasicInformation.vue?vue&type=template&id=4d910d20"
import script from "./InfopointBasicInformation.vue?vue&type=script&lang=js"
export * from "./InfopointBasicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports